define('drops/calendar/calendarItems',[
    'jquery-ui',
    'underscore',
    'moment',
    'when',
    'lq/style',
    'drops/calendar/calendarParameter'
], function (ui, _, moment, when, Style, calendarParameter) {
    'use strict';

    const minutesInAday = 1440;

    var calendarItemsCollide = function (item, otherItem) {
        return item.data.endOfItem.isAfter(otherItem.data.startOfItem)
            && item.data.startOfItem.isBefore(otherItem.data.endOfItem);
    };

    var getNumberOfAvailableColumns = function (item, columns, columnIndexOfItem) {
        var availableColumns = 1;

        for (var i = columnIndexOfItem + 1; i < columns.length; i++) {
            var column = columns[i];

            for (var j = 0; j < column.length; j++) {
                var otherItem = column[j];

                if (calendarItemsCollide(item, otherItem))
                    return availableColumns;
            }

            availableColumns++;
        }

        return availableColumns;
    };

    var layoutGroupOfCalendarItems = function (columns) {
        for (var i = 0; i < columns.length; i++) {
            var column = columns[i];

            for (var j = 0; j < column.length; j++) {
                var item = column[j];
                var colspan = getNumberOfAvailableColumns(item, columns, i);

                item.$element.css({
                    'left': ((i / columns.length) * 100) + '%',
                    'width': ((100 / columns.length) * colspan) + '%'
                });
            }
        }
    };

    var startNewGroupOfCalendarItems = function (lastEncounteredItem, nextItem) {
        return !!lastEncounteredItem && lastEncounteredItem.data.endOfItem.isBefore(nextItem.data.startOfItem);
    };

    var sortCalendarItems = function (items) {
        return items.sort(function (firstItem, secondItem) {
            if (firstItem.data.startOfItem.isBefore(secondItem.data.startOfItem)) return -1;
            if (firstItem.data.startOfItem.isAfter(secondItem.data.startOfItem)) return 1;
            if (firstItem.data.endOfItem.isBefore(secondItem.data.endOfItem)) return -1;
            if (firstItem.data.endOfItem.isAfter(secondItem.data.endOfItem)) return 1;
            return 0;
        });
    };

    var tryAddingItemToExistingColumn = function (columns, item) {
        for (var i = 0; i < columns.length; i++) {
            var column = columns[i];

            if (!calendarItemsCollide(_.last(column), item)) {
                column.push(item);
                return true;
            }
        }

        return false;
    };

    var layoutOverlappingCalendarItems = function (items) {
        var columns = [];
        var lastEncounteredItem = null;

        _.each(sortCalendarItems(items), function (item) {
            if (startNewGroupOfCalendarItems(lastEncounteredItem, item)) {
                layoutGroupOfCalendarItems(columns);

                columns = [];
                lastEncounteredItem = null;
            }

            if (!tryAddingItemToExistingColumn(columns, item))
                columns.push([item]);

            if (lastEncounteredItem === null || item.data.endOfItem.isAfter(lastEncounteredItem.data.endOfItem))
                lastEncounteredItem = item;
        });

        if (columns.length > 0)
            layoutGroupOfCalendarItems(columns);
    };

    var handleItemSelection = function (calendarView, drop) {
        if (!drop.data.eventing.clicked.enabled)
            return;

        drop.$element
            .addClass('clickable')
            .on('click', function () {
                if (drop !== calendarView.selectedItem) {
                    if (drop.data.styles.selected && !drop.data.styles.selected.enabled) {
                        if (calendarView.selectedItem)
                            Style.renderStyle(calendarView.selectedItem.data.styles.normal, calendarView.selectedItem);
                        Style.renderStyle(drop.data.styles.selected, drop);
                    }

                    calendarView.selectedItem = drop;
                }

                drop.triggerEventIfEnabled('clicked');
            });
    };

    var makeResizableAndDraggable = function (drop, drops, calendarView, onlyDraggable, isMultiweek, direction) {
        if (!drop.isEventEnabled('onUpdate')) return;

        var timeslotSize = calendarView.data.timeslotSize; // minutes
        var timeslotHeight = getTimeslotHeight(calendarView);

        var snapInterval = drop.data.resizeSnapInterval;
        if (!snapInterval) snapInterval = timeslotSize;
        var snapHeight = (timeslotHeight / timeslotSize) * snapInterval;

        var weekdayWidth = parseFloat(drop.data.$target.css("width"));

        var timeslotRange = _.range(calendarView.data.dayStart, calendarView.data.dayEnd, timeslotSize);
        var totalHeight = timeslotRange.length * timeslotHeight;

        var onStart = function (event, ui) {
            setOtherItemsOpacity(0.6);
            var group = getGroup().groupMembers;
            _.each(group, function (drop) {
                drop.data.leftOffset = parseFloat(drop.$element.css("left"));
                drop.data.prevState = {
                    top: ui.position.top,
                    left: ui.position.left,
                    height: parseFloat(drop.$element.css("height")),
                    width: parseFloat(drop.$element.css("width"))
                };
            });
        }

        var getGroup = function () {
            for (var i = 0; i < calendarView.data.calendarItemGroups.length; i++) {
                var group = calendarView.data.calendarItemGroups[i];
                if (group.groupMembers[0].data.row[drop.data.idOutput] === drop.data.row[drop.data.idOutput]) {
                    return group;
                }
            }
        }

        var onStop = function (event, ui) {
            snapDropTopAndHeight();

            var group = getGroup().groupMembers;

            var earlyDrop = group[0];
            var lateDrop = group[group.length - 1];


            var earlyTimeDate = getItemTimeData1(earlyDrop);
            var lateTimeData = getItemTimeData1(lateDrop);

            var origStatMomnet = calendarView.getDatetimeFromRow(earlyDrop.data.row, calendarView.data.startOutput);
            var origEndMomnet = calendarView.getDatetimeFromRow(lateDrop.data.row, calendarView.data.endOutput);

            var prveEarlyTimeDate = origStatMomnet.hours() * 60 + origStatMomnet.minutes();
            var prveLateTimeData = origEndMomnet.hours() * 60 + origEndMomnet.minutes();

            var startDateObj = calendarParameter.convert(origStatMomnet);
            var endDateObj = calendarParameter.convert(origEndMomnet);

            if (event.type.includes('drag')) {
                var currentDateMoment = origStatMomnet.startOf('day');
                var currentDateMomente = origEndMomnet.startOf('day');
                if (calendarView.type == "CalendarWeekView") {
                    currentDateMoment = getCurrentPositionDateMoment(earlyDrop.$element.css('left'), earlyDrop, true);
                    currentDateMomente = getCurrentPositionDateMoment(lateDrop.$element.css('left'), lateDrop, true);
                }

                var startMoment = currentDateMoment.clone();
                var startTime = earlyTimeDate.start;
                startMoment.add(startTime, 'minutes');

                var endMoment = currentDateMomente.clone();
                var endTime = lateTimeData.end === minutesInAday ? lateTimeData.end - 1 : lateTimeData.end; // Have to subtract one minute otherweise it will be interpreted as start of the NEXT day
                endMoment.add(endTime, 'minutes');

                startDateObj = calendarParameter.convert(startMoment);
                endDateObj = calendarParameter.convert(endMoment);
                setOtherItemsOpacity(1);
            } else if (earlyTimeDate.start >= 0
                && earlyTimeDate.start !== prveEarlyTimeDate
                && (calendarView.getStartOfCurrentWeek && !calendarView.getStartOfCurrentWeek().isAfter(origStatMomnet) || calendarView.type === "CalendarDayView")) { // true if draging the top
                var moment = origStatMomnet.clone().startOf('day');
                moment.add(earlyTimeDate.start, 'minutes');
                startDateObj = calendarParameter.convert(moment);
                setOtherItemsOpacity(1);
            } else if (lateTimeData.end !== prveLateTimeData) { // true if draging the bottom
                var moment = origEndMomnet.clone().startOf('day');
                moment.add(lateTimeData.end === minutesInAday ? lateTimeData.end - 1 : lateTimeData.end, 'minutes'); // Have to subtract one minute otherweise it will be interpreted as start of the NEXT day
                endDateObj = calendarParameter.convert(moment);
                setOtherItemsOpacity(1);
            }

            var id = drop.data.row[drop.data.idOutput];
            const params = drop.data.updateParams;
            if (params) {
                if (params.newStart) calendarView.piping.parameters.locals.setValue(params.newStart, startDateObj);
                if (params.newEnd) calendarView.piping.parameters.locals.setValue(params.newEnd, endDateObj);
                if (params.id) calendarView.piping.parameters.locals.setValue(params.id, id);
            }
            drop.triggerEventIfEnabled('onUpdate');
        }

        var checkForOverLapping = function (actDrop, top, left, height) {
            var pos3 = actDrop.$element.css(["top", "height"]);
            if (height) {
                pos3.height = height;
            }
            var group = getGroup().groupMembers;
            var a = getCurrentPositionDateMoment(parseInt(left), actDrop)
            var sameDayDrops = drops.filter(function (_drop) {
                if (_drop == actDrop || group.includes(_drop)) return false;
                return _drop.data.startOfDay.startOf('day').isSame(a.startOf('day'));
            });

            return _.some(sameDayDrops, function (sameDayDrop) {
                return doItemsOverlap(sameDayDrop.$element, {top: group.length === 1 ? parseInt(top) : parseInt(pos3.top), height: parseInt(pos3.height)});
            });
        }

        var doItemsOverlap = function ($item1, topHeight) {
            var pos1 = $item1.css(["top", "height"]);
            var pos2 = topHeight;
            pos1.start = round(parseFloat(pos1.top), snapHeight);
            pos1.end = round(pos1.start + parseFloat(pos1.height), snapHeight);
            pos2.start = round(parseFloat(pos2.top), snapHeight);
            pos2.end = round(pos2.start + parseFloat(pos2.height), snapHeight);
            return ((pos1.start > pos2.start && pos1.start < pos2.end) || (pos1.end > pos2.start && pos1.end < pos2.end)
                || (pos2.start > pos1.start && pos2.start < pos1.end) || (pos2.end > pos1.start && pos2.end < pos1.end))
                || (pos2.start === pos1.start && pos2.end === pos1.end);
        }

        var checkForOutOfWeek = function (dropic, top, left) {
            if (!calendarView.getStartOfCurrentWeek) return false;
            var isStartOut =  getCurrentPositionDateMoment(left, dropic).diff(calendarView.getStartOfCurrentWeek());
            var isEndOut = calendarView.getEndOfCurrentWeek().diff(getCurrentPositionDateMoment(left, dropic));
            return  isStartOut < 0 || isEndOut < 0;
        }

        if (!onlyDraggable) {
            if (drop.$element.is('.ui-resizable')) {
                direction = drop.$element
                    .resizable( "option", "handles" ) + ', ' + direction;
                drop.$element
                    .resizable("destroy");
            }
            drop.$element.resizable({
                handles: direction,
                grid: [0, snapHeight],
                start: onStart,
                stop: onStop,
                resize: function (event, ui) {
                    var startMoment = moment(drop.data.row[calendarView.data.startOutput]);

                    ui.position.left = getRoundedToWeekdayLeft(ui.position.left) + drop.data.leftOffset;
                    ui.size.width = drop.data.prevState.width;
                    ui.position.top = round(ui.position.top, snapHeight);
                    ui.size.height = round(ui.size.height, snapHeight);

                    if (calendarView.type !== "CalendarDayView" || !startMoment.isBefore(calendarView.date.startOf('day'))) {
                        // manually check because containment property is buggy
                        if (ui.position.top < 0) {
                            ui.size.height = ui.size.height + ui.position.top;
                            ui.position.top = 0;
                        }

                        if (ui.position.top + ui.size.height > totalHeight) {
                            ui.size.height = ui.size.height - ((ui.position.top + ui.size.height) - totalHeight);
                        }
                    }

                    if (calendarView.data.savePosition && !drop.data.allowItemOverlap && checkForOverLapping(drop, ui.position.top, ui.position.left, ui.size.height)) {
                        ui.position.top = calendarView.data.savePosition.uiTop;
                        ui.size.height = calendarView.data.savePosition.uiHeight;
                    }

                    calendarView.data.savePosition = {
                        uiTop: ui.position.top,
                        uiHeight: ui.size.height
                    };
                }
            });
        }

        if (!isMultiweek) {
            drop.$element.draggable({
                axis: calendarView.type == "CalendarWeekView" ? "x, y" : "y",
                grid: [weekdayWidth, snapHeight],
                scroll: true,
                scrollSensitivity: 100,
                scrollSpeed: 5,
                start: onStart,
                stop: onStop,
                drag: function (event, ui) {
                    var gMembers = getGroup().groupMembers;
                    if (calendarView.type !== "CalendarWeekView") {
                        drop.$element.draggable({axis: 'y'});
                    } else if (gMembers.length > 1) {
                        drop.$element.draggable({axis: 'x'});
                    } else {
                        drop.$element.draggable({axis: 'x, y'});
                    }
                    ui.position.left = getRoundedToWeekdayLeft(ui.position.left);
                    ui.position.top = round(ui.position.top, snapHeight);
                    drop.$element.css("height", getRoundedHeight());

                    // manually check because containment property is buggy
                    var height = parseFloat(drop.$element.css("height"));

                    if (ui.position.top < 0) {
                        ui.position.top = 0;
                    }

                    if (ui.position.top + height > totalHeight) {
                        ui.position.top = totalHeight - height;
                    }

                    var startColumn = drop.data.startOfDay.isoWeekday() - 1;

                    if (ui.position.left < (-weekdayWidth) * startColumn + drop.data.leftOffset) {
                        ui.position.left = (-weekdayWidth) * startColumn;
                    }
                    if (ui.position.left > weekdayWidth * (6 - startColumn) + drop.data.leftOffset) {
                        ui.position.left = weekdayWidth * (6 - startColumn);
                    }
                    var overLappings = [];
                    var hasOverlap = false;
                    if (!drop.data.allowItemOverlap) {
                        for (var i = 0; i < gMembers.length; i++) {
                            var element = gMembers[i];
                            var outOfWeek = checkForOutOfWeek(element, ui.position.top, ui.position.left );
                            var overLapping = checkForOverLapping(element, ui.position.top, ui.position.left);
                            overLappings.push(overLapping);
                            if (overLapping || outOfWeek) {
                                hasOverlap = true;
                                break;
                            }
                        }
                    } else {
                        for (var i = 0; i < gMembers.length; i++) {
                            var element = gMembers[i];
                            var outOfWeek = checkForOutOfWeek(element, ui.position.top, ui.position.left );
                            if (outOfWeek) {
                                hasOverlap = true;
                                break;
                            }
                        }
                    }

                    if (calendarView.data.savePosition && hasOverlap) {
                        ui.position.top = calendarView.data.savePosition.uiTop;
                        ui.position.left = calendarView.data.savePosition.uiLeft;
                    }

                    calendarView.data.savePosition = {
                        uiTop: ui.position.top,
                        uiLeft: ui.position.left
                    };

                    _.each(gMembers, function (d) {
                        var pos1 = d.$element.css(["top", "left"]);
                        d.$element.css({
                            top: pos1.top + ui.position.top,
                            left: ui.position.left,
                            width: weekdayWidth
                        })
                    });
                }
            });
        }

        var setOtherItemsOpacity = function (opacity) {
            var group = getGroup().groupMembers;
            _.each(drops, function (_drop) {
                if (_drop == drop || group.includes(_drop)) return;
                _drop.$element.css("opacity", opacity);
            });
        }

        var getRoundedToWeekdayLeft = function (itemLeft, dropp, flag) {
            if (dropp && flag) {
                dropp.data.leftOffset = 0;
            }
            return round((dropp ? dropp.data.leftOffset : drop.data.leftOffset >= weekdayWidth / 2 ? -weekdayWidth : 0) + itemLeft, weekdayWidth);
        }

        var getCurrentPositionDateMoment = function (left, dropp, flag) {
            var dayOffset = getRoundedToWeekdayLeft(parseFloat(left), dropp, flag) / weekdayWidth;
            var currentDateObj = new Date(dropp ? dropp.data.startOfDay : drop.data.startOfDay);
            currentDateObj.setDate(currentDateObj.getDate() + dayOffset);
            return moment(currentDateObj).startOf("day");
        }


        var snapDropTopAndHeight = function () {
            drop.$element.css("height", getRoundedHeight() + "px");
            drop.$element.css("top", getRoundedTop() + "px");
        }

        var getItemTimeData1 = function (calendarItemDrop) {
            var duration = getRoundedHeight1(calendarItemDrop) / timeslotHeight * timeslotSize;

            var start = calendarView.data.dayStart + (getRoundedTop1(calendarItemDrop) / timeslotHeight * timeslotSize);
            var end = start + duration;

            return {
                start: start,
                end: end
            };
        }

        var getRoundedHeight = function () {
            return round(parseFloat(drop.$element.css("height")), snapHeight);
        }

        var getRoundedTop = function () {
            return round(parseFloat(drop.$element.css("top")), snapHeight);
        }

        var getRoundedHeight1 = function (dropp) {
            return round(parseFloat(dropp.$element.css("height")), snapHeight);
        }

        var getRoundedTop1 = function (dropp) {
            return round(parseFloat(dropp.$element.css("top")), snapHeight);
        }

        var round = function (toRound, roundTo) {
            var isNegative = false;
            if (toRound < 0) {
                toRound = -toRound;
                isNegative = true;
            }
            var rounded = (toRound % roundTo < roundTo / 2) ? toRound - (toRound % roundTo) : toRound + (roundTo - (toRound % roundTo));
            if (isNegative) rounded = -rounded;
            return rounded;
        }
    };

    var getTimeslotHeight = function (calendarView) {
        var viewClassSelector = "." + calendarView.$element.attr("class").replace(/ /g, ".");
        var timeslotHeight = parseFloat($(viewClassSelector + " .timeslot").css("height")); // px3
        return timeslotHeight;
    };

    var round = function (x, roundTo) {
        var rounded = Math.round(x / roundTo) * roundTo;
        if (rounded === minutesInAday) {
            return rounded - 1;
        }
        return rounded;
    };

    var floor = function (x, roundTo) {
        return Math.floor(x / roundTo) * roundTo;
    };

    var getMouseEventMinutes = function (e, data, isMove) {
        var timeslotIndex = $(e.target).index();
        var y = e.offsetY;
        var yTot = timeslotIndex * data.timeslotSize + y;

        var creationInterval = data.creationInterval || data.timeslotSize; // creationInterval editable in property editor?
        if (!!isMove) {
            return round(yTot, creationInterval);
        }
        return floor(yTot, creationInterval);
    };

    var fillUp = function (calendarView, itemsData) {
        calendarView.selectedItem = null;

        if (!itemsData.length)
            return when();

        var drops = calendarView.piping.dropFactory.createDrops(itemsData);

        layoutOverlappingCalendarItems(drops);
        var groupMembers = [];
        var calendarItemGroups = [];
        var ids = []

        _.each(drops, function (drop) {
            calendarView.addDrop(drop);
            handleItemSelection(calendarView, drop);
            drop.piping = calendarView.piping.fork(drop.data.row, calendarView, drop.data.idOutput);

            groupMembers = [];
            _.each(drops, function (d) {
                if (drop && d.data.row[d.data.idOutput] ===
                    drop.data.row[drop.data.idOutput]
                    && !ids.includes(d.data.row[drop.data.idOutput])
                    ) {
                    groupMembers.push(d);
                }
            });
            ids.push(drop.data.row[drop.data.idOutput]);

            if (groupMembers.length > 0)
                calendarItemGroups.push({ groupMembers: groupMembers });
        });

        _.each(calendarItemGroups, function (g) {
            var isMultiweek = false;
            if (calendarView.getStartOfCurrentWeek) {
                var startOfItem = calendarView.getDatetimeFromRow(g.groupMembers[0].data.row, calendarView.data.startOutput);
                var endOfItem = calendarView.getDatetimeFromRow(g.groupMembers[0].data.row, calendarView.data.endOutput);
                var startOfCurrentWeek = calendarView.getStartOfCurrentWeek();
                var endOfCurrentWeek = calendarView.getEndOfCurrentWeek();

                var startIsBetween = startOfItem.isBetween(startOfCurrentWeek, endOfCurrentWeek, undefined, '[]');
                var endIsBetween = endOfItem.isBetween(startOfCurrentWeek, endOfCurrentWeek, undefined, '[]');

                isMultiweek = !startIsBetween || !endIsBetween;

                for (var j = 1; j < g.groupMembers.length - 1; j++) {
                    makeResizableAndDraggable(g.groupMembers[j], drops, calendarView, true, isMultiweek);
                }
                if (!startOfCurrentWeek.isAfter(startOfItem)) {
                    makeResizableAndDraggable(g.groupMembers[0], drops, calendarView, false, isMultiweek, 'n');
                }
                if (!endOfCurrentWeek.isBefore(endOfItem)) {
                    makeResizableAndDraggable(g.groupMembers[g.groupMembers.length - 1], drops, calendarView, false, isMultiweek, 's');
                }
            } else {
                makeResizableAndDraggable(g.groupMembers[0], drops, calendarView, false, false, 'n, s');
            }

        });

        calendarView.data.calendarItemGroups = calendarItemGroups;

        return when.all(_.map(drops, function (drop) {
            drop.render(drop.data.$target);
            return drop;
        }));
    };

    return {

        fillUp: fillUp,

        timeslotMousedown: function ($weekday, dayOfWeek, e) {
            if (e.button !== 0 || $weekday === null || !!this.designData || !this.childDrops[0].data.enableDragAndResize || !this.childDrops[0].data.eventing.onCreate || !this.childDrops[0].data.eventing.onCreate.enabled) return;
            if (!this.designData)
                _.each(this.pool, function (drop) {
                    drop.$element
                        .css({
                            'cursor': 'default',
                            'pointer-events': 'none',
                            "opacity": 0.6
                        });
                });

            var dragStartMinutes = getMouseEventMinutes(e, this.data, false);

            var startOfDay = moment(this.date).startOf('day').add(this.data.dayStart, 'minutes');
            var endOfDay = moment(this.date).startOf('day').add(this.data.dayEnd, 'minutes');

            var item = $.extend(true, {}, this.childDrops[0], {
                data: {
                    $target: $weekday,
                    startOfDay: startOfDay,
                    endOfDay: endOfDay,
                    dayOfWeek: dayOfWeek,
                    startOfItem: moment(startOfDay).add(dragStartMinutes, "minutes"),
                    endOfItem: moment(startOfDay).add(dragStartMinutes, "minutes"),
                    row: {},
                    eventArg: this.data.eventArg,
                    tooltipOutput: this.data.tooltipOutput,
                    idOutput: this.data.idOutput
                }
            });

            var self = this;
            fillUp(this, [item]).then(function (dropArr) {
                var drop = dropArr[0];
                drop.applyPosition();
                drop.$element.css("pointer-events", "none");

                self.itemCreation = {
                    dragStartMinutes: dragStartMinutes,
                    inProgress: true,
                    isCreatable: false,
                    pageX: e.pageX,
                    pageY: e.pageY,
                    drop: drop
                };
            });
        },

        timeslotMouseup: function (e) {
            if (e.button !== 0 || !this.itemCreation || !this.itemCreation.inProgress) return;
            if (!this.designData)
                _.each(this.pool, function (drop) {
                    drop.$element
                        .css({
                            'cursor': 'all-scroll',
                            'pointer-events': '',
                            "opacity": 1
                        });
                });
            if (!this.itemCreation.isCreatable) {
                this.itemCreation.drop.$element.remove();
                delete this.itemCreation.drop;
            } else {
                this.itemCreation.drop.$element.css("pointer-events", "auto");

                var startMoment = this.itemCreation.drop.data.startOfItem;
                var endMoment = this.itemCreation.drop.data.endOfItem;

                if (startMoment.isSame(endMoment)) {
                    endMoment.add(this.itemCreation.drop.data.resizeSnapInterval || this.data.timeslotSize, 'minutes');
                }
                var parameters = this.piping.parameters;
                const params = this.itemCreation.drop.data.createParams;
                if (params) {
                    if (this.getStartOfCurrentWeek) {
                        if (params.newStart) parameters.locals.setValue(params.newStart, calendarParameter.convert(this.getStartOfCurrentWeek().add(this.itemCreation.drop.data.dayOfWeek, 'day').add(startMoment, 'minutes')));
                        if (params.newEnd) parameters.locals.setValue(params.newEnd, calendarParameter.convert(this.getStartOfCurrentWeek().add(this.itemCreation.drop.data.dayOfWeek, 'day').add(endMoment, 'minutes')));
                    } else {
                        if (params.newStart) parameters.locals.setValue(params.newStart, calendarParameter.convert(startMoment));
                        if (params.newEnd) parameters.locals.setValue(params.newEnd, calendarParameter.convert(endMoment));
                    }
                }

                this.itemCreation.drop.triggerEventIfEnabled('onCreate');
            }
            this.itemCreation = {
                dragStartMinutes: null,
                inProgress: false,
                isCreatable: false,
                drop: null
            };
        },

        timeslotMousemove: function (e) {
            if (!this.itemCreation || !this.itemCreation.inProgress) return;
            var distance = Math.sqrt(Math.pow(e.pageX - this.itemCreation.pageX, 2) + Math.pow(e.pageY - this.itemCreation.pageY, 2));
            var timeslotHeight = getTimeslotHeight(this);
            if (distance > timeslotHeight / 3) {
                this.itemCreation.isCreatable = true;
            }

            var dragMinutes = getMouseEventMinutes(e, this.data, true);

            var startOfDay = moment(this.date).startOf('day').add(this.data.dayStart, 'minutes');

            var savedStart = this.itemCreation.drop.data.startOfItem.clone();
            var savedEnd = this.itemCreation.drop.data.endOfItem.clone();

            if (dragMinutes >= this.itemCreation.dragStartMinutes) {
                this.itemCreation.drop.data.startOfItem = moment(startOfDay).add(this.itemCreation.dragStartMinutes, "minutes");
                this.itemCreation.drop.data.endOfItem = moment(startOfDay).add(dragMinutes, "minutes");
            }
            else {
                this.itemCreation.drop.data.startOfItem = moment(startOfDay).add(dragMinutes, "minutes");
                this.itemCreation.drop.data.endOfItem = moment(startOfDay).add(this.itemCreation.dragStartMinutes, "minutes");
            }

            var overlapp = false;
            if (!this.itemCreation.drop.data.allowItemOverlap) {
                var startClone = this.itemCreation.drop.data.startOfItem.clone();
                var endClone = this.itemCreation.drop.data.endOfItem.clone();

                if (this.getStartOfCurrentWeek) {
                    startClone = this.getStartOfCurrentWeek().add(this.itemCreation.drop.data.dayOfWeek, 'day').add(this.itemCreation.drop.data.startOfItem, "minutes");
                    endClone = this.getStartOfCurrentWeek().add(this.itemCreation.drop.data.dayOfWeek, 'day').add(this.itemCreation.drop.data.endOfItem, "minutes");
                }

                var sameDayDrops = this.pool.filter(function (_drop) {
                    return _drop.data.startOfDay.startOf('day').isSame(startClone.startOf('day'));
                });

                startClone.add(this.itemCreation.drop.data.startOfItem, "minutes");

                for (var i = 0;  i < sameDayDrops.length; i++) {
                    var sameDayDrop = sameDayDrops[i];
                    var isStartBetweenOrSame = sameDayDrop.data.startOfItem.isBetween(startClone, endClone, undefined, '[]') || sameDayDrop.data.startOfItem.isSame(startClone);
                    var isEndBetweenOrSame = sameDayDrop.data.endOfItem.isBetween(startClone, endClone, undefined, '[]') || sameDayDrop.data.endOfItem.isSame(endClone);
                    if (isStartBetweenOrSame || isEndBetweenOrSame) {
                        overlapp = true;
                        break;
                    }
                };
            }

            if (!overlapp) {
                this.itemCreation.drop.applyPosition();
            } else {
                this.itemCreation.drop.data.startOfItem = savedStart;
                this.itemCreation.drop.data.endOfItem = savedEnd;
            }
        }

    };
});

